<div class="w-full h-full flex flex-col gap-2">
    <input
        class="hidden"
        type="file"
        #fileDropRef
        id="fileDropRef"
        multiple
        (change)="onFilesSelected($event.target.files)"
        [accept]="onlyImages ? 'image/*' : '*'"
    />

    <div
        appDnd
        class="flex flex-col flex-1 justify-center items-center gap-2 py-12 px-4 border-2 border-solid border-iota-outline rounded-2xl"
        (fileDropped)="onFilesSelected($event)"
    >
        <button class="btn btn-outline btn-sm rounded-full gap-2" (click)="onSelectClick()">
            <iota-icon icon="arrow-up-circle" size="lg"> </iota-icon>
            <span>{{ buttonText | hyphenate }}</span>
        </button>
        <span class="py-2 text-sm text-dropdown-hover-dark" i18n>or</span>
        <span i18n>Drag and drop a file here</span>
    </div>

    <div class="flex flex-row justify-start items-center gap-4 pt-4" *ngFor="let file of files">
        <img *ngIf="isDisplayableImage(file)" [src]="filePreviews.get(file.name)" class="w-16 h-auto" />

        <iota-icon *ngIf="!isDisplayableImage(file)" [icon]="getHeroFileIcon(file)" size="2"> </iota-icon>

        <small>{{ file.name }}</small>

        <button class="btn btn-xs btn-ghost btn-circle" (click)="removeFile(file)">
            <iota-icon icon="x-mark"> </iota-icon>
        </button>
    </div>
</div>
